// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {

    function getScrollTop() {
        return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    }

    if (document.getElementById("myTopBtn")) {
        if (getScrollTop() > 20) {
            document.getElementById("myTopBtn").style.display = "block";
        } else {
            document.getElementById("myTopBtn").style.display = "none";
        }

    }

}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

/*
* Chris@eckmandesign.com 5/22/18
*/
$(document).ready(function() {

    var waitForEl = function(selector, callback) {

        if ($(selector).length) {

            callback();

        } else {

            setTimeout(function() {

                waitForEl(selector, callback);

            }, 100);

        }

    };

  	//waits for yotpo reviews to be loaded and then removed the target="_blank"
    waitForEl('.yotpo-reviews-carousel .yotpo-display-wrapper', function() {
        $('.yotpo-reviews-carousel a[target="_blank"]').removeAttr('target');
    });

});

$(document).ready(function() {

	/* size chart modal popup */
	
	$("a#single_image").fancybox();
	
	/* Using custom settings */
	
	$("a#inline").fancybox({
		'hideOnContentClick': true
	});

	/* Apply fancybox to multiple items */
	
	$("a.group").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
		'overlayShow'	:	false
	});
	
});